<div class="sidebar-wrapper">
  <div class="sidebar-column document-column">
    <div class="column-header" *ngIf="pages && pages.length > 0">
      <h4>Outline ({{ pages.length }} {{ pages.length === 1 ? 'page' : 'pages' }})</h4>
    </div>
    <div class="document-pages">
      <div class="document-page-list">
        <!-- Drop zone before first page -->
        <div
          role="button"
          class="page-drop-zone"
          (click)="onInsertPage(pageLibrary!, reportConfig!, 0)"
        >
          <div class="drop-zone-content">+</div>
        </div>

        <ng-container *ngFor="let page of pages; let i = index">
          <div
            class="document-page-item"
            [class.selected]="selectedPageIndex === i"
            (click)="onPageClick(i)"
            draggable="true"
            (dragstart)="onPageDragStart($event, i)"
            (dragover)="onPageDragOver($event)"
            (drop)="onPageDrop($event, i)"
            (dragleave)="onPageDragLeave($event)"
          >
            <div class="page-preview">
              <img
                *ngIf="page.thumbnail"
                [src]="page.thumbnail"
                [style.aspect-ratio]="getPageAspectRatio(page)"
                [alt]="page.name || 'Page thumbnail'"
                class="page-thumbnail-image"
              />
              <div *ngIf="!page.thumbnail" class="preview-placeholder" [style.aspect-ratio]="getPageAspectRatio(page)">
                <mat-icon>insert_drive_file</mat-icon>
              </div>
              <span class="page-number">{{ i + 1 }}</span>
            </div>

            <button
              class="delete-page-btn"
              (click)="deletePage(i); $event.stopPropagation()"
              title="Remove page"
              mat-icon-button
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <!-- Drop zone after page -->
          <div
            *ngIf="i < pages.length - 1"
            role="button"
            class="page-drop-zone"
            (click)="onInsertPage(pageLibrary!, reportConfig!, i + 1 )"
          >
            <div class="drop-zone-content">+</div>
          </div>
        </ng-container>

        <!-- Drop zone after last page -->
        <div
          *ngIf="pages.length > 0"
          role="button"
          class="page-drop-zone"
          (click)="onInsertPage(pageLibrary!, reportConfig!, pages.length || 0 )"
        >
          <div class="drop-zone-content">+</div>
        </div>

        <div *ngIf="!pages || pages.length === 0" class="empty-state">
          <mat-icon>note_add</mat-icon>
          <p>No pages yet</p>
          <small>Insert from the Page Library using the '+' button above</small>
        </div>
      </div>
    </div>
  </div>
</div>
